<template>
  <modal :modal-key="'welcome-sign-up'" :class-style="'modal modal--welcomeback'"
         :body-style="'welcone_pad'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_welcome_sign_up_welcome }} {{ userDetails.username }}!</h1>
      <p v-if="this.registrationPoints.freeGamePrize" class="free_game_secondary_title">
       {{getTranslations.home_modals_welcome_sign_up_you_won}}  [{{freePlayPrize.name}}]
      </p>
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      <div v-if="!this.registrationPoints.freeGamePrize">{{ getTranslations.home_modals_welcome_sign_up_proof_your_knowledge }}</div>
      <div  v-if="this.registrationPoints.freeGamePrize"> {{getTranslations.home_modals_welcome_sign_up_you_will}} </div>
      <p v-if="show2stepsOnlyOrNoneInForgot() && this.registrationPoints.freeGamePrize" class="note">{{ getTranslations.home_modals_welcome_sign_up_note }}
      </p>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import RegistrationFlowMixin from '@/common/mixins/flow';


export default {
  name: 'welcome-signup',
  mixins: [RegistrationFlowMixin],
  components: {
    Modal,
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'postGameSettings',
    ]),
    ...mapState('profile', [
      'freePlayPrize',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeSignup.vue